module.exports = __webpack_public_path__ + "static/sun-3deaf3d4c704b6daae054fbcde8bdc8f.svg";